import React from 'react';
import { Container, Row, Card, Col, Button, Nav } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { HelpOutline } from '@material-ui/icons';
import Faq from "react-faq-component";
import './style.css';
import *  as soon from "../../images/soon.png";


export default function(){

  const isMasterAgent = () => {
    return localStorage.getItem("masterAgent") == 1 ? true : false;
  }

  const data = {
    //title: "FAQ (How it works)",
    rows: [
      {
        title: "1. Quem poderá ser parceiro desse programa?",
        content: `
        <div class="card-body text-left">
          Como é um programa para parceiros que atuam no B2B, o parceiro deverá ter Cadastro de CNPJ ativo na Receita Federal, com possibilidade de emissão de nota como Agenciamento/Intermediações de Negócios. Sendo um revendedor do segmento de TI/Telecom
        </div>
        `,
      },
      {
        title: "2. Quem é a ScanSource Master Agent?",
        content: `
          <div class="card-body text-left">
            Somos uma nova unidade de negócios na SCANSOURCE, trazendo para o Brasil o modelo de negócio da INTELISYS, empresa do grupo SCANSOURCE, localizada nos EUA. A INTELISYS é uma empresa consolidada, com 25 anos no mercado, provendo soluções através das principais operadoras Globais e Provedores de Serviços. Nosso principal objetivo é trabalharmos com uma visão de ganhos a longo prazo através de comissões recorrentes.
          </div>
        `
      },
      {
        title: "3. O que são “Fornecedores de Serviços”?",
        content: `
          <div class="card-body text-left">
          São as Operadoras de Telecom e Provedores de Serviços, que possuem contrato com a ScanSource Master Agent, provendo uma diversidade de soluções em TI | Cloud | Segurança | UCC | Telecom
          </div>
        `
      },
      {
        title: "4. A ScanSource Master Agent atuará diretamente com clientes finais?",
        content: `
          <div class="card-body text-left">
          NÃO, nosso programa será desenvolvido apenas com canais intermediadores de negócios, denominados AGENTES/ REVENDEDORES/ INTELGRADORES.
          </div>
        `
      },
      {
        title: "5. É possível fazer parte do Programa de Agentes, mesmo não tendo conhecimento nas soluções ofertadas pelos Fornecedores de Serviços?",
        content: `
          <div class="card-body text-left">
          SIM, nós daremos todo suporte necessário para que você consiga atender as necessidades dos seus clientes, desde uma solução simples, até as mais complexas. Você terá acesso ao time de engenharia pré-vendas dos fornecedores.
          </div>
        `
      },
      {
        title: "6. Quem emitirá o contrato de prestação de serviço ao meu cliente?",
        content: `
          <div class="card-body text-left">
            Os Fornecedores de Serviços, serão os responsáveis por gerar o Contrato de Prestação de Serviços aos seus clientes, caberá ao Fornecedor de Serviços cumprir todas as cláusulas constantes nesse contrato.
          </div>
        `
      },
      {
        title: "7. Quem será o responsável por implantar as soluções em meus clientes, bem como suporte técnico?",
        content: `
          <div class="card-body text-left">
            Todos os Fornecedores de Serviços (Operadoras de Telecom/Provedores de Serviços) serão responsáveis diretos por implementar os serviços contratados, contando apenas com o seu monitoramento na implantação. O suporte técnico, sendo local ou acesso remoto, será prestado pelos Fornecedores de Serviços.
          </div>
        `
      },
      {
        title: "8. Quem irá faturar os serviços fornecidos aos meus clientes?",
        content: `
          <div class="card-body text-left">
            Todos os Fornecedores de Serviços, serão os responsáveis pelo faturamento ao cliente final, bem como, administrar análise de crédito, pós vendas e cobrança.
          </div>
        `
      },
      {
        title: "9. Como será o pagamento das comissões das vendas? Quem é o responsável pelo repasse das minhas comissões?",
        content: `
          <div class="card-body text-left">
            A ScanSource Master Agent será a responsável direta por efetuar os pagamentos das comissões mensais, para isso, contamos com uma plataforma digital para a gestão de comissões dos agentes parceiros. Como Agenciador Master de todo o processo, teremos total controle junto aos Fornecedores de Serviços e programações de pagamentos mensais de todos os parceiros.
          </div>
        `
      },
      {
        title: "10. Qual o investimento necessário para participar do programa?",
        content: `
          <div class="card-body text-left">
            Não há nenhum investimento inicial por parte do Agente, nem cumprimento de metas. Apenas um contrato firmado com a Scansource, para que possamos repassar nossas responsabilidades, de forma transparente, em todos os processos
          </div>
        `
      },
      {
        title: "11. Qual o risco ao entrar nesse programa?",
        content: `
          <div class="card-body text-left">
            Nossa operação, baseia-se nos princípios da negociação justa e da conduta ética, mantemos contratos jurídicos, que, garantem a proteção da carteira, para que nossos parceiros sejam proprietários dos seus clientes e tenham todo o respaldo técnico de vendas e pós vendas, durante toda a vigência do contrato.
          </div>
        `
      }
    ],
  };

  return (<>
    <Container>
      <Row className="mt-4">
        <HelpOutline className="icon-title"/>
        <h5 className="title-dashboard">Perguntas Frequentes - Master Agent</h5>
      </Row>
      {isMasterAgent() ? (
        <>
          <Row>
            <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 p-4 col-12">
              <Faq data={data}
              />
            </Card.Body>
          </Row>
        </>) :
        <>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card.Body className="shadow bg-white rounded text-center m-2 col-6 pt-5">
                <Row className="text-center row">
                  <Col xs="12" className="mb-5 mt-5">
                    <img className="d-inline-block mb-3 icon-program" src={soon} alt="" width="50" />
                    <h5 className="title-dashboard">Em breve!</h5>
                  </Col>
                </Row>
              </Card.Body>
            </Col>
          </Row>
        </>
      }
    </Container>
  </>);
};
